// NEOGRIPX — Personalización del kit (snippet nx-personaliza)
// Vista previa en directo del texto personalizado y paso de lo elegido al
// pedido como propiedades del kit. Colores y fuentes provisionales.
(function () {
  const root = document.querySelector('[data-nxp]');
  if (!root) return;
  const form = root.closest('form');
  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => Array.from(root.querySelectorAll(sel));

  // Paleta provisional: colores lisos y degradados (from → to)
  const COLORS = [
    { name: 'Blanco', hex: '#FFFFFF' },
    { name: 'Negro', hex: '#15131A' },
    { name: 'Rojo', hex: '#E30613' },
    { name: 'Naranja', hex: '#FF6A00' },
    { name: 'Amarillo', hex: '#FFD400' },
    { name: 'Verde flúor', hex: '#39E44A' },
    { name: 'Azul', hex: '#0057FF' },
    { name: 'Cian', hex: '#00C2FF' },
    { name: 'Morado', hex: '#7B2FFF' },
    { name: 'Rosa', hex: '#FF1FA9' },
    { name: 'Plata', hex: '#B8BEC8' },
    { name: 'Oro', hex: '#D4A62A' },
    { name: 'Fuego', from: '#FFB000', to: '#E30613' },
    { name: 'Neón', from: '#7B2FFF', to: '#FF00FF' },
    { name: 'Océano', from: '#00E0FF', to: '#0047FF' }
  ];
  const STROKES = COLORS.filter((c) => c.hex);
  const FONTS_URL = 'https://fonts.googleapis.com/css2?family=Kanit:ital,wght@1,800&family=Russo+One&family=Anton&family=Saira+Stencil+One&family=Kaushan+Script&display=swap';

  const on = $('[data-nxp-on]');
  const panel = $('[data-nxp-panel]');
  const board = $('[data-nxp-preview]');
  const defs = $('[data-nxp-defs]');
  const group = $('[data-nxp-group]');
  const l1 = $('[data-nxp-l1]');
  const l2 = $('[data-nxp-l2]');
  const t1 = $('[data-nxp-text1]');
  const t2 = $('[data-nxp-text2]');
  const err = $('[data-nxp-err]');
  const props = $$('[data-nxp-props] input');
  const fonts = $$('.nxp-font');

  const state = {
    font: $('.nxp-font.is-active') || fonts[0],
    color: COLORS[3],
    stroke: false,
    strokeColor: COLORS[1],
    bg: 'dark'
  };

  // Muestras de color
  const swatch = (c) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'nxp-swatch';
    b.title = c.name;
    b.setAttribute('aria-label', c.name);
    b.style.background = c.hex || `linear-gradient(135deg, ${c.from}, ${c.to})`;
    if (c.hex === '#FFFFFF') b.classList.add('is-light');
    return b;
  };
  const strokeBox = $('[data-nxp-stroke-colors]');
  COLORS.forEach((c) => {
    c.el = swatch(c);
    c.el.addEventListener('click', () => { state.color = c; render(); });
    $('[data-nxp-colors]').appendChild(c.el);
  });
  STROKES.forEach((c) => {
    c.strokeEl = swatch(c);
    c.strokeEl.addEventListener('click', () => { state.strokeColor = c; render(); });
    strokeBox.appendChild(c.strokeEl);
  });

  // Fuentes: se cargan al abrir el bloque, no antes
  let fontsLoaded = false;
  const loadFonts = () => {
    if (fontsLoaded) return;
    fontsLoaded = true;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONTS_URL;
    link.onload = () => {
      const loads = fonts.map((f) => document.fonts.load(`${f.dataset.style} ${f.dataset.weight} 40px "${f.dataset.family}"`, 'ABCÑ123'));
      Promise.all(loads).catch(() => {}).then(render);
    };
    document.head.appendChild(link);
  };
  fonts.forEach((f) => {
    const spec = f.querySelector('.nxp-font-spec');
    spec.style.fontFamily = `"${f.dataset.family}", sans-serif`;
    spec.style.fontWeight = f.dataset.weight;
    spec.style.fontStyle = f.dataset.style;
    f.addEventListener('click', () => { state.font = f; render(); });
  });

  const colorLabel = (c) => c.hex ? `${c.name} (${c.hex})` : `${c.name} (degradado ${c.from} → ${c.to})`;
  const zones = () => $$('[data-nxp-zone]:checked');

  // Degradado del SVG (se ajusta a cada línea de texto)
  const paint = (c) => {
    if (c.hex) return c.hex;
    defs.innerHTML = `<linearGradient id="nxpGrad" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${c.from}"/><stop offset="1" stop-color="${c.to}"/></linearGradient>`;
    return 'url(#nxpGrad)';
  };

  const FS = 100; // tamaño base; luego el grupo se escala para encajar
  function render() {
    const f = state.font;
    const v1 = t1.value.trim();
    const v2 = t2.value.trim();
    const empty = !v1 && !v2;
    l1.textContent = v1 || (empty ? 'Tu nombre' : '');
    l2.textContent = v2;
    [l1, l2].forEach((t) => {
      t.style.fontFamily = `"${f.dataset.family}", sans-serif`;
      t.style.fontWeight = f.dataset.weight;
      t.style.fontStyle = f.dataset.style;
      t.setAttribute('font-size', FS);
      t.setAttribute('fill', paint(state.color));
      if (state.stroke) {
        t.setAttribute('stroke', state.strokeColor.hex);
        t.setAttribute('stroke-width', FS * 0.09);
      } else {
        t.removeAttribute('stroke');
      }
    });
    group.style.opacity = empty ? 0.3 : 1;
    l1.setAttribute('y', 0);
    l2.setAttribute('y', l1.textContent ? FS * 0.98 : 0);

    // Encaja el texto en la mesa de diseño (con margen) y lo centra
    group.removeAttribute('transform');
    let bb;
    try { bb = group.getBBox(); } catch (e) { bb = null; }
    if (bb && bb.width && bb.height) {
      const maxH = l2.textContent ? 180 : 130;
      const s = Math.min(480 / bb.width, maxH / bb.height, 2.4);
      const tx = 300 - (bb.x + bb.width / 2) * s;
      const ty = 130 - (bb.y + bb.height / 2) * s;
      group.setAttribute('transform', `translate(${tx} ${ty}) scale(${s})`);
    }

    // Estado de los controles
    const sample = v1 || v2 || 'Ginés';
    fonts.forEach((b) => {
      b.classList.toggle('is-active', b === state.font);
      b.querySelector('.nxp-font-spec').textContent = sample;
    });
    COLORS.forEach((c) => c.el.classList.toggle('is-active', c === state.color));
    STROKES.forEach((c) => c.strokeEl.classList.toggle('is-active', c === state.strokeColor));
    $$('[data-nxp-stroke-on]').forEach((b) => b.classList.toggle('is-active', (b.dataset.nxpStrokeOn === '1') === state.stroke));
    strokeBox.hidden = !state.stroke;
    $('[data-nxp-color-name]').textContent = state.color.name;
    $('[data-nxp-font-name]').textContent = f.dataset.nxpFont;
    $$('[data-nxp-bg]').forEach((b) => b.classList.toggle('is-active', b.dataset.nxpBg === state.bg));
    board.dataset.bg = state.bg;
    $('[data-nxp-meta]').textContent = [f.dataset.nxpFont, state.color.name, state.stroke ? 'Trazo ' + state.strokeColor.name.toLowerCase() : 'Sin trazo'].join('  ·  ');
    $$('.nxp-zone').forEach((z) => z.classList.toggle('is-active', z.querySelector('input').checked));
    $('[data-nxp-count1]').textContent = `${t1.value.length}/${t1.maxLength}`;
    $('[data-nxp-count2]').textContent = `${t2.value.length}/${t2.maxLength}`;

    const zs = zones();
    $('[data-nxp-zones-count]').textContent = zs.length ? `${zs.length} de 3` : '';
    const where = $('[data-nxp-where]');
    if (!zs.length) {
      where.textContent = 'Elige al menos una zona del kit.';
    } else {
      const names = zs.map((z) => z.value.replace(' (los dos lados)', ''));
      const list = names.length > 1 ? names.slice(0, -1).join(', ') + ' y ' + names[names.length - 1] : names[0];
      let txt = 'Irá en: ' + list;
      if (v2 && zs.some((z) => z.hasAttribute('data-nxp-zone-one-line'))) txt += ` · En las vainas, solo «${v1 || v2}»`;
      where.textContent = txt;
    }
    if (err.textContent && (v1 || v2) && zs.length) err.textContent = '';
    writeProps();
  }

  // Lo elegido viaja al pedido como propiedades del kit
  function writeProps() {
    const active = on.checked && (t1.value.trim() || t2.value.trim());
    const values = [
      zones().map((z) => z.value).join(', '),
      t1.value.trim(),
      t2.value.trim(),
      state.font.dataset.nxpFont + ' (' + state.font.dataset.family + ')',
      colorLabel(state.color),
      state.stroke ? colorLabel(state.strokeColor) : 'Sin trazo'
    ];
    props.forEach((input, i) => {
      input.value = values[i];
      input.disabled = !active || !values[i];
    });
    // Zonas que se cobran: neogripx.js las suma al precio y al carrito
    const count = active ? zones().length : 0;
    if (root.dataset.nxpCount !== String(count)) {
      root.dataset.nxpCount = count;
      root.dispatchEvent(new CustomEvent('nxp:change', { bubbles: true }));
    }
  }

  on.addEventListener('change', () => {
    panel.hidden = !on.checked;
    root.classList.toggle('is-open', on.checked);
    if (on.checked) { loadFonts(); requestAnimationFrame(render); }
    else { err.textContent = ''; writeProps(); }
  });
  [t1, t2].forEach((t) => t.addEventListener('input', render));
  $$('[data-nxp-zone]').forEach((z) => z.addEventListener('change', render));
  $$('[data-nxp-stroke-on]').forEach((b) => b.addEventListener('click', () => { state.stroke = b.dataset.nxpStrokeOn === '1'; render(); }));
  $$('[data-nxp-bg]').forEach((b) => b.addEventListener('click', () => { state.bg = b.dataset.nxpBg; render(); }));

  // Ejemplos rápidos para inspirar
  const IDEAS = { name: ['NACHO', ''], dorsal: ['GINÉS', '227'], date: ['12.05.2019', ''] };
  $$('[data-nxp-idea]').forEach((b) => b.addEventListener('click', () => {
    const idea = IDEAS[b.dataset.nxpIdea];
    t1.value = idea[0];
    t2.value = idea[1];
    render();
    t1.focus();
    t1.select();
  }));

  // Si el bloque está abierto, no se deja comprar sin texto o sin zona
  if (form) {
    form.addEventListener('submit', (e) => {
      if (!on.checked) return;
      let msg = '';
      if (!t1.value.trim() && !t2.value.trim()) msg = 'Escribe el texto que quieres en tu kit, o desmarca la personalización.';
      else if (!zones().length) msg = 'Elige al menos una zona donde poner tu texto.';
      if (!msg) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      err.textContent = msg;
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, true);
  }

  // Guardar el diseño como imagen (para guardarlo o mandarlo por WhatsApp)
  $('[data-nxp-save]').addEventListener('click', () => {
    const W = 1200, H = 600;
    const c = document.createElement('canvas');
    c.width = W; c.height = H;
    const ctx = c.getContext('2d');
    ctx.fillStyle = state.bg === 'dark' ? '#121214' : '#F3F2EF';
    ctx.fillRect(0, 0, W, H);
    const f = state.font;
    const lines = [t1.value.trim(), t2.value.trim()].filter(Boolean);
    if (!lines.length) lines.push('Tu nombre');
    let size = 200;
    const setFont = () => { ctx.font = `${f.dataset.style} ${f.dataset.weight} ${size}px "${f.dataset.family}"`; };
    setFont();
    const widest = () => Math.max(...lines.map((l) => ctx.measureText(l).width));
    const lineH = () => size * 0.98;
    const fit = Math.min(1000 / widest(), (lines.length > 1 ? 400 : 280) / (lineH() * lines.length));
    size = Math.min(size * fit, 260);
    setFont();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    const top = H / 2 - (lineH() * (lines.length - 1)) / 2 - 10;
    let fill = state.color.hex;
    if (!fill) {
      const w = widest();
      const g = ctx.createLinearGradient(W / 2 - w / 2, top - size / 2, W / 2 + w / 2, top + lineH() * (lines.length - 1) + size / 2);
      g.addColorStop(0, state.color.from);
      g.addColorStop(1, state.color.to);
      fill = g;
    }
    lines.forEach((l, i) => {
      const y = top + i * lineH();
      if (state.stroke) {
        ctx.lineJoin = 'round';
        ctx.lineWidth = size * 0.09;
        ctx.strokeStyle = state.strokeColor.hex;
        ctx.strokeText(l, W / 2, y);
      }
      ctx.fillStyle = fill;
      ctx.fillText(l, W / 2, y);
    });
    ctx.font = '600 20px Inter, sans-serif';
    ctx.textAlign = 'left';
    ctx.fillStyle = state.bg === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.45)';
    ctx.fillText('NEOGRIPX  ·  ' + $('[data-nxp-meta]').textContent.toUpperCase(), 40, H - 36);
    c.toBlob((blob) => {
      if (!blob) return;
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'mi-diseno-neogripx.png';
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    }, 'image/png');
  });

  // En móvil la vista previa se queda fija justo debajo de la barra de navegación
  // (que baja o sube según esté abierta la barra de avisos)
  let topQueued = false;
  const setTop = () => {
    topQueued = false;
    const nav = document.querySelector('nav');
    const bottom = nav ? Math.max(0, Math.round(nav.getBoundingClientRect().bottom)) : 64;
    root.style.setProperty('--nxp-top', bottom + 'px');
  };
  window.addEventListener('scroll', () => {
    if (!topQueued && on.checked) { topQueued = true; requestAnimationFrame(setTop); }
  }, { passive: true });
  window.addEventListener('resize', setTop);
  setTop();

  render();
})();
